// Diseño de la tienda en línea (catálogo público). Lo elige cada negocio en
// Configuración y se guarda en negocios.tienda_diseno (sql/112). Solo se
// aceptan valores de estas listas; lo demás vuelve al valor por defecto.

export const PLANTILLAS = [
  { valor: 'dividida', nombre: 'Dividida', ayuda: 'Texto a un lado y tu foto completa al otro.' },
  { valor: 'velo', nombre: 'Foto completa', ayuda: 'Tu foto de fondo con las letras encima.' },
  { valor: 'galeria', nombre: 'Galería', ayuda: 'Foto enmarcada y el texto debajo, centrado.' },
  { valor: 'texto', nombre: 'Solo texto', ayuda: 'Sin foto: tu logo y tu frase.' },
];

// Fondo del bloque de texto (y de la portada sin foto).
export const FONDOS = [
  { valor: 'crema', nombre: 'Crema', muestra: '#F6EFE9' },
  { valor: 'rubor', nombre: 'Rubor', muestra: 'color-mix(in srgb, var(--cb-acento) 12%, #FFF8F6)' },
  { valor: 'blanco', nombre: 'Blanco', muestra: '#FFFFFF' },
  { valor: 'arena', nombre: 'Arena', muestra: '#EDE3D8' },
  { valor: 'oscuro', nombre: 'Vino', muestra: 'color-mix(in srgb, #000 58%, var(--cb-acento))' },
];

export const FUENTES = [
  { valor: 'cormorant', nombre: 'Elegante', familia: "'Cormorant Garamond', Georgia, serif", peso: 600 },
  { valor: 'playfair', nombre: 'Clásica', familia: "'Playfair Display', Georgia, serif", peso: 600 },
  { valor: 'montserrat', nombre: 'Moderna', familia: "'Montserrat', 'DM Sans', sans-serif", peso: 500 },
  { valor: 'bodoni', nombre: 'Editorial', familia: "'Bodoni Moda', 'Didot', Georgia, serif", peso: 500 },
];

export const BOTONES = [
  { valor: 'oscuro', nombre: 'Oscuro' },
  { valor: 'acento', nombre: 'Mi color' },
  { valor: 'borde', nombre: 'Solo borde' },
];

export const ENFOQUES = [
  { valor: 'top', nombre: 'Arriba' },
  { valor: 'center', nombre: 'Centro' },
  { valor: 'bottom', nombre: 'Abajo' },
];

export const ESQUINAS = [
  { valor: 'redondas', nombre: 'Redondas', radio: '16px' },
  { valor: 'suaves', nombre: 'Suaves', radio: '8px' },
  { valor: 'rectas', nombre: 'Rectas', radio: '0px' },
];

export const ALINEACIONES = [
  { valor: 'izquierda', nombre: 'Izquierda' },
  { valor: 'centro', nombre: 'Centro' },
];

export const DISENO_DEFECTO = {
  plantilla: 'dividida', fondo: 'crema', fuente: 'cormorant', boton: 'oscuro',
  enfoque: 'center', esquinas: 'redondas', alineacion: 'izquierda',
  subtitulo: '', textoBoton: '', anuncio: '',
};

export const SUBTITULO_DEFECTO = 'Elige tus favoritas, agrégalas a tu bolsa y envíanos tu pedido en un solo mensaje.';
export const BOTON_DEFECTO = 'Ver productos';

const LIMITES = { subtitulo: 160, textoBoton: 30, anuncio: 90 };
const LISTAS = { plantilla: PLANTILLAS, fondo: FONDOS, fuente: FUENTES, boton: BOTONES, enfoque: ENFOQUES, esquinas: ESQUINAS, alineacion: ALINEACIONES };

// Siempre devuelve un diseño completo y válido.
export function normalizarDiseno(d) {
  const o = d && typeof d === 'object' && !Array.isArray(d) ? d : {};
  const r = { ...DISENO_DEFECTO };
  Object.entries(LISTAS).forEach(([k, lista]) => { if (lista.some((x) => x.valor === o[k])) r[k] = o[k]; });
  Object.entries(LIMITES).forEach(([k, max]) => {
    // eslint-disable-next-line no-control-regex
    if (typeof o[k] === 'string') r[k] = o[k].replace(/[\u0000-\u001f<>]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, max);
  });
  return r;
}

// Variables CSS que usa catalogo.css (fuente de títulos, esquinas y color de
// los botones de toda la tienda: "Mi color" = el color de la marca).
export function variablesDiseno(d) {
  const f = FUENTES.find((x) => x.valor === d.fuente) || FUENTES[0];
  const e = ESQUINAS.find((x) => x.valor === d.esquinas) || ESQUINAS[0];
  const boton = d.boton === 'acento' ? 'var(--cb-acento)' : 'var(--cb-tinta)';
  return { '--cb-titulos': f.familia, '--cb-titulos-peso': f.peso, '--cb-radio': e.radio, '--cb-boton': boton };
}
